module.exports = __webpack_public_path__ + "static/media/worst-aroma.6286b148.png";